var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_vm._v("Redirecting to checkout...")]),_c('v-progress-circular',{staticClass:"mt-8",attrs:{"size":70,"color":"accent","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }